
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Map from "../../Base/Map.vue";
import DeleteBox from "../../Base/DeleteBox.vue";
import BaseTable from "../../Base/BaseTable.vue";
import { City, CityPoint } from "@/models/City";
import { MapOptions } from "@/models/Map";
import { cloneDeep, forIn, isEqual } from "lodash";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: {
    Map,
    BaseTable,
    DeleteBox,
  },
})
class CityLocation extends Vue {
  @Prop({ default: "EN" }) readonly languageID!: string;
  @Prop({ default: null }) readonly cityData!: City;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly step!: boolean;
  @Prop({ default: "" }) readonly slug!: string;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  locationSlug = "";
  viewLocationSlug = "";
  showInfo = false;
  showSavePanel = false;
  cityDataObject = {} as City;

  created(): void {
    this.$v.$touch();
    this.cityDataObject = cloneDeep(this.cityData);
  }

  get getTableData(): CityPoint[] {
    const cityPointArray: CityPoint[] = [];
    forIn(this.cityDataObject.locations, (val: CityPoint) => {
      cityPointArray.push(val);
    });
    return cityPointArray;
  }
  get getLocationData(): CityPoint {
    if (this.locationSlug !== "") {
      if (this.cityDataObject.locations[this.locationSlug] === undefined) {
        this.showInfo = false;
        return {} as CityPoint;
      }
      if (
        this.cityDataObject.locations[this.locationSlug].notes === undefined
      ) {
        this.cityDataObject.locations[this.locationSlug].notes = "";
      }
      return this.cityDataObject.locations[this.locationSlug];
    }
    return {} as CityPoint;
  }
  get isDisabled(): boolean {
    if (this.isEditingLocked) {
      return false;
    } else {
      return true;
    }
  }

  get getLocationSlug(): string {
    return this.viewLocationSlug;
  }

  get showDeleteButton(): boolean {
    if (this.getLocationData.slug === "centre_point") {
      return false;
    }
    return true;
  }

  get getTitle(): string {
    if (this.slug !== "") {
      return this.cityDataObject.locations[this.slug].name.en;
    } else {
      return this.getLocationData.name.en;
    }
  }

  get locationCenterPin(): string {
    if (this.getLocationData.slug === "centre_point") {
      return require("@/assets/images/map/city-center-blue.svg");
    }
    return require("@/assets/images/map/city-pink.svg");
  }
  get getLocationMarkerPoints(): MapOptions[] {
    var arr = [];
    var cityCentreMarker: MapOptions = {
      position: {
        lat: this.getLocationData.lat_long.latitude,
        lng: this.getLocationData.lat_long.longitude,
      },
      title: this.getTitle,
      draggable: this.isDisabled,
      slug: this.getLocationData.slug,
      clickable: false,
      zIndex: 1000,
      radius: 10,
      icon: this.locationCenterPin,
    };
    arr.push(cityCentreMarker);
    forIn(this.cityDataObject.locations, (val: CityPoint) => {
      if (val.slug !== this.getLocationData.slug) {
        var locationMarker: MapOptions = {
          position: {
            lat: val.lat_long.latitude,
            lng: val.lat_long.longitude,
          },
          title: val.name.en,
          draggable: false,
          clickable: true,
          slug: val.slug,
          zIndex: 100,
          radius: 10,
          icon: this.getLocationGrayCenter(val),
        };
        arr.push(locationMarker);
      }
    });
    return arr;
  }

  get getSavePanelLock(): boolean {
    if (this.isSavedOrDiscard) {
      this.showSavePanel = false;
      return false;
    } else {
      return this.showSavePanel;
    }
  }

  getLocationGrayCenter(val: CityPoint): string {
    if (val.slug === "centre_point") {
      return require("@/assets/images/map/city-center-gray.svg");
    }
    return require("@/assets/images/map/city-gray.svg");
  }

  mapData(place: any): void {
    if (this.getLocationData.slug == "centre_point") {
      this.cityDataObject.centre_point.latitude = place.latitude;
      this.cityDataObject.centre_point.longitude = place.longitude;
    }
    this.getLocationData.lat_long.latitude = place.latitude;
    this.getLocationData.lat_long.longitude = place.longitude;
    this.onValueChanged();
  }

  onRowSelected(row: CityPoint): void {
    this.locationSlug = row.slug;
    this.showInfo = true;
  }
  openDeleteBox(): void {
    this.$bvModal.show("team-modal-delete");
  }
  deleteItem(): void {
    var data = {
      city: this.cityDataObject.slug,
      locationSlug: this.getLocationData.slug,
    };
    this.$store.dispatch("cityStore/deleteLocation", data).then((results) => {
      if (results === "success") {
        this.showInfo = false;
      }
    });
  }
  onValueChanged(): void {
    this.cityDataObject.locations[this.locationSlug] = this.getLocationData;
    var data = {
      type: "location",
      cityData: this.cityDataObject,
      selectable: true,
    };
    if (!isEqual(this.cityData, this.cityDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", data);
  }
  openLocation(value: string): void {
    this.locationSlug = value;
    this.viewLocationSlug = value;
  }

  @Watch("isEditingLocked")
  onIsEditingLockedChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }
  @Watch("cityData")
  onCityDataChange(value: City): void {
    this.cityDataObject = cloneDeep(value);
  }
  @Validations()
  validations = {
    getLocationData: {
      name: {
        en: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(160),
        },
      },
    },
  };
}

export default CityLocation;
